import ChiefAnalyticsTable from './chief-analytics-table'

export default ChiefAnalyticsTable
